export default { 
  cepData: [],
}
